import type { FC } from 'react';
import { observer } from 'mobx-react-lite';
import { Footnote1, Title3 } from '@sbol/nova';
import { Button } from '../../lib/ui/Button';
import MessageAttentionImg from './img/message_attention.svg?react';
import styles from './ErrorView.module.scss';

export const SurveyFormFetchingErrorView: FC = observer(() => (
  <div className={styles.ErrorView}>
    <MessageAttentionImg />
    <Title3 className={styles.Title}>Не удалось загрузить анкету</Title3>
    <Footnote1 color="secondary" className={styles.Subtitle}>
      Пожалуйста, попробуйте зайти позже
    </Footnote1>
    <Button className={styles.Button} text="Обновить страницу" onClick={() => location.reload()} />
  </div>
));
